module.exports = __webpack_public_path__ + "static/media/StraightArrow.b1db4132.png";


//////////////////
// WEBPACK FOOTER
// ./src/Features/TelestrationsVideoLibrary/Assets/StraightArrow.png
// module id = 7504
// module chunks = 0